export function normalizePhone(phone) {
  if (!phone) {
    return null;
  }

  phone = phone.trim();

  if (phone.startsWith('8')) {
    phone = '+7' + phone.slice(1);
  } else if (phone.startsWith('7')) {
    phone = '+' + phone;
  }

  return phone;
}



// WEBPACK FOOTER //
// ./src/utils/normalize-phone.js